module.exports.VEHICLE_BATTLE_BALLOON = 'battle_balloon'
module.exports.VEHICLE_GALLEY = 'galley'
module.exports.VEHICLE_MECHANICAL_BEHOLDER = 'mechanical_beholder'
module.exports.VEHICLE_ROWBOAT = 'rowboat'
